import React, { memo } from 'react';
import classNames from 'classnames';

import Table, { Column, Row } from '../helpers/Table';
import ContextMenuWrapper from './ContextMenuWrapper';

const sortIcon = (sort, name) => {
  const direction = sort.get(name);

  if (direction) {
    return direction > 0 ? (
      <i aria-hidden="true" className="fa fa-caret-up" />
    ) : (
      <i aria-hidden="true" className="fa fa-caret-down" />
    );
  }

  return null;
};

const CategoryTableComponent = ({ onDelete, onClick, onEdit, agreementCategories, sort, isSuper }) => {
  const rows = agreementCategories.map(agreementCategory => {
    const agreementCategoryUpdated = agreementCategory.set(
      'isLinkableIcon',
      agreementCategory.get('isLinkable') ? <i className="fa fa-check" /> : '',
    );

    return (
      <Row
        key={agreementCategory.get('id')}
        className={classNames({ 'bold-table-row': agreementCategory.get('parentId') === '' })}
        data={agreementCategoryUpdated}
      />
    );
  });

  const valueWrapper = ContextMenuWrapper(onDelete, onEdit, isSuper);

  return (
    <Table className="table table-striped table-hover">
      <Column
        className="cursor-pointer"
        field="category"
        onClick={() => onClick('category')}
        style={{ width: '45%' }}
        valueWrapper={valueWrapper}
      >
        Category Name {sortIcon(sort, 'category')}
      </Column>
      <Column
        className="cursor-pointer"
        field="parent.category"
        onClick={() => onClick('parent')}
        style={{ width: '45%' }}
        valueWrapper={valueWrapper}
      >
        Parent Category {sortIcon(sort, 'parent')}
      </Column>
      <Column field="isLinkableIcon" title="Is Linkable" valueWrapper={valueWrapper} />
      {rows}
    </Table>
  );
};

export const CategoryTable = memo(CategoryTableComponent);
